import { Record, Union } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { tuple_type, lambda_type, class_type, record_type, bool_type, option_type, union_type, string_type, int32_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { printf, toText } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { tryInt } from "./Helpers.fs.js";
import { create, isMatch } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/RegExp.js";
import { State, defaultState, State_$reflection } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.Elmish.1.0.0/DatePicker/Types.fs.js";
import { map } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { day, month, year, create as create_1 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Date.js";

export class ValidationRule extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mandatory", "MandatoryNumber", "MandatoryWithMaxLength", "OptionalWithMaxLength", "MatchesRegex", "ValidateEmailAddress"];
    }
}

export function ValidationRule_$reflection() {
    return union_type("Validation.ValidationRule", [], ValidationRule, () => [[], [], [["Item", int32_type]], [["Item", int32_type]], [["regex", string_type], ["errorMsg", string_type]], []]);
}

export class FormField extends Record {
    constructor(Value, Rule, Error$, Touched) {
        super();
        this.Value = Value;
        this.Rule = Rule;
        this.Error = Error$;
        this.Touched = Touched;
    }
}

export function FormField_$reflection() {
    return record_type("Validation.FormField", [], FormField, () => [["Value", string_type], ["Rule", option_type(ValidationRule_$reflection())], ["Error", option_type(string_type)], ["Touched", bool_type]]);
}

export function FormField_Init_Z1F39563A(rule) {
    return new FormField("", rule, undefined, false);
}

export function FormField_InitWithDefault_74789EBD(rule, defaultValue) {
    const field = FormField_Init_Z1F39563A(rule);
    return new FormField(defaultValue, field.Rule, field.Error, true);
}

export function FormField__get_IsValid(x) {
    const matchValue = x.Rule;
    const matchValue_1 = x.Touched;
    const matchValue_2 = x.Error;
    let matchResult;
    if (matchValue != null) {
        switch (matchValue.tag) {
            case 2: {
                if (matchValue_1) {
                    if (matchValue_2 == null) {
                        matchResult = 2;
                    }
                    else {
                        matchResult = 7;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case 3: {
                if (matchValue_2 == null) {
                    matchResult = 3;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case 1: {
                if (matchValue_2 == null) {
                    matchResult = 4;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case 4: {
                if (matchValue_1) {
                    if (matchValue_2 == null) {
                        matchResult = 5;
                    }
                    else {
                        matchResult = 7;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case 5: {
                if (matchValue_1) {
                    if (matchValue_2 == null) {
                        matchResult = 6;
                    }
                    else {
                        matchResult = 7;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            default:
                if (matchValue_1) {
                    if (matchValue_2 == null) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 7;
                    }
                }
                else {
                    matchResult = 7;
                }
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return true;
        case 4:
            return true;
        case 5:
            return true;
        case 6:
            return true;
        default:
            return false;
    }
}

export function validationMsg(field, newValue) {
    const matchValue = field.Rule;
    if (matchValue != null) {
        switch (matchValue.tag) {
            case 2: {
                const len = matchValue.fields[0] | 0;
                if (newValue.length === 0) {
                    return "Bitte füllen Sie das Pflichtfeld aus";
                }
                else if (newValue.length > len) {
                    return toText(printf("Bitte verwenden Sie maximal %i Zeichen"))(len);
                }
                else {
                    return undefined;
                }
            }
            case 3: {
                const len_1 = matchValue.fields[0] | 0;
                if (newValue.length > len_1) {
                    return toText(printf("Bitte verwenden Sie maximal %i Zeichen"))(len_1);
                }
                else {
                    return undefined;
                }
            }
            case 1:
                if (newValue.length === 0) {
                    return "Bitte füllen Sie das Pflichtfeld aus";
                }
                else if (tryInt(newValue) == null) {
                    return "Bitte geben Sie nur einen Zahl ein";
                }
                else {
                    return undefined;
                }
            case 4: {
                const msg = matchValue.fields[1];
                const regex = matchValue.fields[0];
                if (isMatch(create(regex), newValue)) {
                    return undefined;
                }
                else {
                    return msg;
                }
            }
            case 5:
                if (isMatch(/.+\u0040.+\..+/gu, newValue)) {
                    return undefined;
                }
                else {
                    return "Bitte geben Sie eine E-Mail-Adresse ein";
                }
            default:
                if (newValue.length === 0) {
                    return "Bitte füllen Sie das Pflichtfeld aus";
                }
                else {
                    return undefined;
                }
        }
    }
    else {
        return undefined;
    }
}

export function update(field, newValue) {
    return new FormField(newValue, field.Rule, validationMsg(field, newValue), true);
}

export class DateValidationRule extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MandatoryDate", "ValidationFunc"];
    }
}

export function DateValidationRule_$reflection() {
    return union_type("Validation.DateValidationRule", [], DateValidationRule, () => [[], [["Item", tuple_type(lambda_type(option_type(class_type("System.DateTime")), bool_type), string_type)]]]);
}

export class DateFormField extends Record {
    constructor(Value, Rule, Error$, DatePickerState, Touched) {
        super();
        this.Value = Value;
        this.Rule = Rule;
        this.Error = Error$;
        this.DatePickerState = DatePickerState;
        this.Touched = Touched;
    }
}

export function DateFormField_$reflection() {
    return record_type("Validation.DateFormField", [], DateFormField, () => [["Value", option_type(class_type("System.DateTime"))], ["Rule", option_type(DateValidationRule_$reflection())], ["Error", option_type(string_type)], ["DatePickerState", State_$reflection()], ["Touched", bool_type]]);
}

export function DateFormField_Init_Z492D238E(rule) {
    return new DateFormField(undefined, rule, undefined, new State(defaultState.Today, defaultState.InputFocused, defaultState.ReferenceDate, true, defaultState.ForceClose, defaultState.TitleFormat, (rule != null) ? ((rule.tag === 1) && false) : true), false);
}

export function DateFormField__get_IsValid(x) {
    const matchValue = x.Rule;
    const matchValue_2 = x.Error;
    let matchResult, f;
    if (matchValue != null) {
        if (matchValue.tag === 1) {
            if (matchValue_2 == null) {
                matchResult = 2;
                f = matchValue.fields[0][0];
            }
            else {
                matchResult = 3;
            }
        }
        else if (x.Touched) {
            if (matchValue_2 == null) {
                matchResult = 1;
            }
            else {
                matchResult = 3;
            }
        }
        else {
            matchResult = 3;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return true;
        case 2:
            return f(x.Value);
        default:
            return false;
    }
}

export function dateValidationMsg(field, newValue) {
    const matchValue = field.Rule;
    if (matchValue != null) {
        if (matchValue.tag === 1) {
            const e = matchValue.fields[0][1];
            const f = matchValue.fields[0][0];
            if (f(newValue)) {
                return undefined;
            }
            else {
                return e;
            }
        }
        else if (newValue == null) {
            return "Bitte füllen Sie das Pflichtfeld aus";
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

export function dateUpdate(field, newState, newValue, referenceData) {
    const valueWithoutTimezone = map((d) => create_1(year(d), month(d), day(d)), newValue);
    const newState_1 = (referenceData != null) ? (new State(newState.Today, newState.InputFocused, referenceData, newState.AutoClose, newState.ForceClose, newState.TitleFormat, newState.ShowDeleteButton)) : newState;
    return new DateFormField(valueWithoutTimezone, field.Rule, dateValidationMsg(field, valueWithoutTimezone), newState_1, true);
}

//# sourceMappingURL=Validation.fs.js.map
